export default __webpack_public_path__ + "static/media/bathroom1-after-1920w.ed0c9923.webp";